<template>
    <div class="ppv2-flex ppv2-flex-col ppv2-items-center">
        <div class="ppv2-relative ppv2-w-24 ppv2-h-24">
            <svg class="ppv2-w-24 ppv2-h-24 progress-circle" viewBox="0 0 36 36">
                <path
                    class="ppv2-text-gray-200"
                    stroke="currentColor"
                    stroke-width="3"
                    fill="none"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                    class="ppv2-text-blue-400"
                    stroke="currentColor"
                    stroke-width="3"
                    fill="none"
                    :stroke-dasharray="`${percentage}, 100`"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
            </svg>
            <div class="ppv2-absolute ppv2-inset-0 ppv2-flex ppv2-items-center ppv2-justify-center">
                <div
                    class="ppv2-w-16 ppv2-h-16 ppv2-bg-blue-100 ppv2-rounded-full ppv2-flex ppv2-items-center ppv2-justify-center"
                >
                    <img src="/v2/images/pp.png" alt="playpro" class="ppv2-w-8 ppv2-h-8" />
                </div>
            </div>
        </div>
        <!-- <span class="ppv2-text-2xl poppinsBold ppv2-text-blue-400 ppv2-mt-2"> {{ percentage }}% </span> -->
    </div>
</template>

<script>
export default {
    name: 'ProgressCircle',
    props: {
        percentage: { type: Number, required: true },
    },
}
</script>

<style scoped>
.progress-circle {
    transform: rotate(-90deg);
}
</style>
